module.exports = __webpack_public_path__ + "img/others.78449a23.png";